// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js'

if (!customElements.get('article-equipment')) {
  customElements.define(
    'article-equipment',
    class ArticleEquipment extends window.BAO.CustomElement() {
      constructor () {
        super()

        if (!this.els.slide) return

        this.progressEl = this.querySelector(
          '[data-article-equipment-el="progress"]',
        )

        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {
        if (window.innerWidth > 767) {
          this.els.slides.element.classList.remove('car-Carousel_Slides')

          this.els.slide.elements.forEach(slide => {
            slide.classList.remove('car-Carousel_Slide')
          })

          return
        }

        return new KeenSlider(this.els.slides.element, {
          selector: '.car-Carousel_Slide',
          drag: true,
          loop: true,
          mode: 'snap',
          rubberband: false,
          slides: {
            origin: 'auto',
            perView: 2,
            spacing: 10,
          },
          breakpoints: {
            '(min-width: 768px)': {
              disabled: true,
            },
          },
          dragged: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.track.details.rel,
              )
            })
            if (this.progressEl) {
              const progressTrack = instance.track.details.progress
              const progressAmount = progressTrack >= 0.9 ? 0 : progressTrack
              const movementPercentage = progressAmount * 100
              this.progressEl.style.setProperty(
                '--progress',
                `${movementPercentage}%`,
              )
            }
          },
          created: () => {
            this.setAttribute('data-initialized', 'true')
          },
        })
      }
    },
  )
}
